// extracted by mini-css-extract-plugin
export default {"selectContainer":"LanguageSelect_selectContainer__4cbFE","select":"LanguageSelect_select__vmqgJ","label":"LanguageSelect_label__u5t8x"};